import { styled } from '@mui/material';

export const StyledLinkToEdit = styled('div')(() => ({
  color: 'var(--color-neutral-500)',
  cursor: 'pointer',
  paddingTop: '8px',
}));

export const StyledLinkToDelete = styled('div')(() => ({
  display: 'flex',
  margin: 'auto',
  marginLeft: 0,
  color: 'var(--color-red-500)',
  cursor: 'pointer',
  fontWeight: 'var(--font-weight-medium)',
  fontSize: 'var(--font-size-medium)',
}));

export const StyledDataSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  fontWeight: 'var(--font-weight-medium)',
  fontSize: 'var(--font-size-medium)',
}));

export const SectionHeading = styled('div')(({ theme }) => ({
  fontWeight: 'var(--font-weight-semi-bold)',
  fontSize: 'var(--font-size-x-large)',
  marginBottom: `${theme.spacing(4)}`,
}));

export const StyledUserData = styled('div')(({ theme }) => ({
  display: 'flex',
}));
